const MAX_TEXT = 200

function clean(value, max = MAX_TEXT) {
  return typeof value === 'string' ? value.trim().slice(0, max) : ''
}

function safeObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {}
}

export function unwrapDeviceEnvelope(body) {
  if (body && typeof body.code === 'number') {
    return { ok: body.code === 0, data: safeObject(body.data), error: clean(body.msg || body.error) }
  }
  return { ok: Boolean(body?.ok), data: safeObject(body?.data || body), error: clean(body?.error || body?.message) }
}

export function normalizeVibokeyDevice(value) {
  const device = safeObject(value)
  const agent = safeObject(device.agent)
  const system = safeObject(device.system)
  const network = safeObject(device.network)
  return {
    deviceId: clean(device.device_id, 120),
    name: clean(device.display_name, 120) || 'Vibokey USB Audio',
    vendorId: clean(device.vendor_id, 8),
    productId: clean(device.product_id, 8),
    status: device.status === 'online' ? 'online' : 'offline',
    usbConnected: device.usb_connected === true,
    lastSeenAt: clean(device.last_seen_at, 64),
    boundAt: clean(device.bound_at, 64),
    agent: {
      version: clean(agent.version, 80),
      platform: clean(agent.platform, 80),
      architecture: clean(agent.architecture, 80),
    },
    system: {
      machineName: clean(system.machine_name, 160),
      windowsCaption: clean(system.windows_caption, 160),
      windowsVersion: clean(system.windows_version, 160),
      windowsBuild: clean(system.windows_build, 160),
      windowsArchitecture: clean(system.windows_architecture, 160),
    },
    network: {
      interfaceName: clean(network.interface_name, 120),
      localIpv4: clean(network.local_ipv4, 120),
      publicIp: clean(network.public_ip, 120),
      country: clean(network.country, 120),
      region: clean(network.region, 120),
      city: clean(network.city, 120),
      asn: clean(network.asn, 120),
    },
  }
}

export async function fetchVibokeyDevices(token, { fetchImpl = fetch, signal } = {}) {
  if (!clean(token)) {
    const error = new Error('missing_access_token')
    error.status = 401
    throw error
  }
  const response = await fetchImpl('/chamii/devices', {
    cache: 'no-store',
    signal,
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  })
  const body = await response.json().catch(() => ({}))
  const payload = unwrapDeviceEnvelope(body)
  if (!response.ok || !payload.ok) {
    const error = new Error(payload.error || `HTTP ${response.status}`)
    error.status = response.status
    throw error
  }
  const devices = Array.isArray(payload.data.devices) ? payload.data.devices : []
  return devices.map(normalizeVibokeyDevice).filter((device) => device.deviceId)
}
